import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "SectionEdit" })
export default class SectionEdit extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public formData: any = {
        idMaster: null,
        name: null,
        title: null,
        market: null,
        allowedUserDescriptions: null,
        allowedRoles: []
    };
    public markets: any[] = [];
    public allowedRoles: any[] = [];
    public validationErrors: any[] = [];
    public isCustomUsers: boolean = false;

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get isSectionEditVisible() {
        return this.$store.getters["myFileSharingStore/isSectionEditVisible"];
    }

    get sectionIdMaster() {
        return this.$store.getters["myFileSharingStore/sectionIdMaster"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("isSectionEditVisible") async onSectionEditVisibleUpdate(newValue: boolean) {
        if (newValue) {
            await this.getData();
            document.body.classList.add("overflow");
            (<any>this).$refs.sectionedit.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.sectionedit.classList.remove("show");
        }
    }

    public async getData() {
        this.isLoading = true;

        const result = (await Axios.post(this.routes.MyBremboPartsFileSharingManagement_GetSectionEditData, { sectionIdMaster: this.sectionIdMaster })).data;
        this.allowedRoles = result.allowedRoles;
        this.markets = result.markets;

        this.formData.idMaster = this.sectionIdMaster;

        if (this.sectionIdMaster !== "-1") {
            this.formData.name = result.fileSharingSectionInfo.name;
            this.formData.title = result.fileSharingSectionInfo.title;
            this.formData.market = result.fileSharingSectionInfo.market;
            this.formData.allowedRoles = result.fileSharingSectionInfo.allowedRoles;
            this.formData.allowedUserDescriptions = result.fileSharingSectionInfo.allowedUserDescriptions.join(',');
        }

        if (this.formData.allowedUserDescriptions) {
            this.isCustomUsers = true;
        }

        this.isLoading = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        try {
            await Axios.post(this.routes.MyBremboPartsFileSharingManagement_SaveSection, this.formData);

            window.location.href = this.routes.MyBremboPartsFileSharing_DocumentList;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public closeDialog() {
        this.$store.commit("myFileSharingStore/setSectionEditVisible", false);
        this.$store.commit("myFileSharingStore/setSectionIdMaster", null);
        this.formData = { idMaster: null, name: null, title: null, market: null, allowedUserDescriptions: null, allowedRoles: [] };
        this.isLoading = false;
        this.isLoadingForm = false;
        this.isCustomUsers = false;
        this.validationErrors = [];
    }

    public autogenerateNameSection() {
        if (this.sectionIdMaster === "-1") {
            this.validationErrors = [];
            let title = this.formData.title.replace(/[^\w\s]/gi, '').trim().replace(/\s+/g, '_');

            this.formData.name = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
        }
    }

    public setAllowedRoles() {
        if (this.formData.allowedRoles.length === 0 && !this.isCustomUsers) {
            this.formData.allowedRoles = [this.allowedRoles[0].value];
        } else {
            this.formData.allowedRoles = [];
        }

        this.formData.allowedUserDescriptions = null;
        this.isCustomUsers = false;
    }

    public setCustomUsers() {
        this.isCustomUsers = !this.isCustomUsers;
        this.formData.allowedRoles = [];
    }

    public disableCustomUsers() {
        this.formData.allowedUserDescriptions = null;
        this.isCustomUsers = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
}